module.exports = __webpack_public_path__ + "static/media/award-solid.b76b8f69.svg";